module.exports = __webpack_public_path__ + "static/media/send.babf75c4.svg";